import FileSaver from "file-saver";
import Resizer from "react-image-file-resizer";
import {getStandardResolutionByName} from "../../util/state/commonFunctions";
import { ExpiredActionProps } from "./models/models";

const createFile = (data: any, fileName: string, type: string) => {
    const blob = new Blob([data], {
        type
    });
    FileSaver.saveAs(blob, fileName);
}

/**
 * Resize img
 * @param file
 * @return {file} resized file if it had the type image
 */
const resizeImg = async (file: File) => {
    if (!!file?.type?.startsWith('image')) {
        // @ts-ignore
        const maxResolution = getStandardResolutionByName(window.appConfig.MAX_RESOLUTION_FOR_IMG_RESIZE);
        // @ts-ignore
        const minResolution = getStandardResolutionByName(window.appConfig.MIN_RESOLUTION_FOR_IMG_RESIZE);
        // @ts-ignore
        const quality = window.appConfig.QUALITY_FOR_IMG_RESIZE || 100;

        return await new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                maxResolution?.width,
                maxResolution?.height,
                "JPEG",
                quality,
                0,
                (uri: any) => {
                    resolve(uri);
                },
                "file",
                minResolution?.width,
                minResolution?.height
            );
        });
    } else {
        return file;
    }
}

const generateExpiredActionProps = (actionType: string, selectedPractices: any[] | [] | null): ExpiredActionProps => {

    const isMultipleSelection = !!selectedPractices && (selectedPractices.length > 1);
    return {
        actionType,
        expiredCodes: selectedPractices?.map((x: any) => x.expiredCode) || [],
        raDetails: isMultipleSelection? undefined : {
            raNumber: selectedPractices?.at(0).raCode,
            raDate: selectedPractices?.at(0).createdDatetime,
            rentalType: selectedPractices?.at(0).rentalType || '',
            plateNumber: selectedPractices?.at(0).plate,
            delayDays: selectedPractices?.at(0).delayDays,
            clientId: selectedPractices?.at(0).customerSapId,
            customerNameSurname: selectedPractices?.at(0).customerNameSurname,
            phoneNumber: selectedPractices?.at(0).customerMobile,
            companyName: selectedPractices?.at(0).companyName,
            acriss: selectedPractices?.at(0).effectiveAcriss,
        },
        returnDetails: isMultipleSelection? undefined : {
            date: selectedPractices?.at(0).effectiveCheckOutDate,
            location: selectedPractices?.at(0).effectiveCheckOutLocationLabel
        }
    };
}

export {
    createFile,
    resizeImg,
    generateExpiredActionProps
}